<template>
  <div :class="['section-patient-container', { 'history': isHistory }]">
    <el-row class="section">
      <uploadable-avatar :enableUpload="true" :photoSetter="photoSetter" :photoData="sectionData" :getCustomer="getCustomer" :isHistory="isHistory" />
      <el-col :span="20">
        <el-row class="header" :span="12">
          <el-col class="right" :span="8" style="font-family: 'Sukhumvit-Bold';">ข้อมูลคนไข้</el-col>
        </el-row>
        <el-row class="_jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('name') }]" :span="8">ชื่อคนไข้</el-col>
          <el-col class="detail" :span="15" :offset="1">{{ sectionData.name }}</el-col>
        </el-row>
        <el-row class="_jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('gender') }]" :span="8">เพศ</el-col>
          <el-col class="detail" :span="15" :offset="1">{{ sectionData.gender }}</el-col>
        </el-row>
        <el-row class="_jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('age') }]" :span="8">อายุ</el-col>
          <el-col class="detail" :span="15" :offset="1">{{ sectionData.age }} ปี</el-col>
        </el-row>
        <el-row class="_jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('weight') }]" :span="8">น้ำหนัก</el-col>
          <el-col class="detail" :span="15" :offset="1">{{ sectionData.weight }} กก.</el-col>
        </el-row>
        <el-row class="_jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('height') }]" :span="8">ส่วนสูง</el-col>
          <el-col class="detail" :span="15" :offset="1">{{ sectionData.height }} ซม.</el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('type') }]" :span="8">ประเภทผู้ป่วย</el-col>
          <el-col class="detail" :span="15" :offset="1">{{ sectionData.type }}</el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('diseases') }]" :span="8">โรค</el-col>
          <el-col class="diseases" :span="15" :offset="1">
            <li class="detail" v-for="disease in sectionData.diseases" :key="disease.name" style="text-indent: -26px; margin-left: 25px; margin-bottom: 15px;"><span>{{ disease.name }}</span>
              <div style="margin-left: 25px;" v-for="(note, index) in disease.note" :key="disease.name+index"><span>{{ note }}</span></div>
            </li>
          </el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('skills') }]" :span="8">กิจกรรมอาศัยทักษะ</el-col>
          <el-col class="skills" :span="15" :offset="1">
            <div v-show="generalSkills.length" class="text">ทักษะทั่วไป</div>
            <li class="detail" v-for="(skill) in generalSkills" :key="skill">{{ skill }}</li>
            <div v-show="othersSkills.length" class="text">ทักษะอิื่นๆ</div>
            <li class="detail" v-for="(skill) in othersSkills" :key="skill">{{ skill }}</li>
          </el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('activity') }]" :span="8">กิจกรรมทั่วไป</el-col>
          <el-col class="activity" id="section-activity" :span="15" :offset="1">
            <li class="detail" v-for="(activity, index) in sectionData.activity" :key="index">{{ activity }}</li>
          </el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('environment') }]" :span="8">สิ่งแวดล้อมที่บ้านคนไข้</el-col>
          <el-col class="environment" id="section-environment" :span="15" :offset="1">
            <li class="detail" v-for="(environment, index) in sectionData.environment" :key="index">{{ environment }}</li>
          </el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('doctorNote') }]" :span="8">สิ่งที่คุณหมอให้เฝ้าระวังเป็นพิเศษ</el-col>
          <el-col class="detail note" :span="15" :offset="1">{{ sectionData.doctorNote }}</el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('patientNote') }]" :span="8">เรื่องอื่น ๆ</el-col>
          <el-col class="detail note" :span="15" :offset="1">
            <div v-if="sectionData.patientNote">
              ลูกค้า : {{ sectionData.patientNote }}
            </div>
            <div v-if="sectionData.caregiverNote">
              <i class="el-icon-mobile-phone"></i>
              แอดมิน : {{ sectionData.caregiverNote }}
            </div>
          </el-col>
        </el-row>
        <el-row class="small-container _jtfct_bl">
          <el-col :class="['header-18-gray', 'right', { 'change': hasChange('note') }]" :span="8">แอดมินโน้ต</el-col>
          <el-col class="detail note" :span="15" :offset="1">{{ sectionData.note }}</el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>

  .text {
    color: #A2A7B2;
    font-size: 18px;
    font-weight: 400;
    line-height: 2.2;
  }

  .small-container {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .right {
    text-align: right;
  }

  .el-button {
    width: 120px;
  }

  .section-patient-container {
    background: #F1F3F6;

    .section {
      padding-top: 70px;
      padding-left: 80px;
      padding-right: 80px;
      padding-bottom: 66px;
    }

    .header {
      font-family: 'Sukhumvit-SemiBold';
      padding-bottom: 20px;
      padding-top: 20px;
      font-size: 22px;
      font-weight: 900;
      color: #606266;
      margin-bottom: 0;
    }

    .detail {
      font-family: 'Sukhumvit';
      color: #676E81;
      font-weight: 300;
      font-size: 18px;
      line-height: 29px;
    }

    .change {
      color: #FF577F !important;
    }

    &.history {
      background: #F9F9FA;

      div {
        color: #A2A7B2;
      }
    }
  }

  .padding-container {
    padding: 70px 80px 66px 80px;
  }

  ._jtfct_bl {
    display: flex;
    align-items: baseline;
  }

</style>

<script>
import UploadableAvatar from './UploadableAvatar'
import { Value, Readable } from '../../model/ModelUtil'

export default {
  name: 'sectionPatient',
  components: {
    UploadableAvatar,
  },
  data () {
    return {
      generalSkills:
        this.sectionData.skills.filter(
          s => Value.skill.generalAll().includes(s)).map((item) => {
          return `${Readable.skill.from(item)}${(item === 'injection' && this.sectionData.skillOptions.injection.detail.length > 0) ? (' (' + this.sectionData.skillOptions.injection.detail + ')') : ''}`
        }),
      othersSkills:
        this.sectionData.skills.filter(
          s => Value.skill.othersAll().includes(s)).map((item) => {
          return `${Readable.skill.from(item)}${(item === 'injection' && this.sectionData.skillOptions.injection.detail.length > 0) ? (' (' + this.sectionData.skillOptions.injection.detail + ')') : ''}`
        }),
    }
  },
  props: {
    sectionData: {
      type: Object,
      required: true,
    },
    enableUpload: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHistory: {
      type: Boolean,
      required: false,
    },
    getCustomer: {
      type: Function,
      required: true,
    },
    historiesData: {
      type: Array[String],
      required: true,
    },
  },
  computed: {
    photoSetter () {
      return this.$api.Patient.setPhoto
    },
  },
  watch: {
    sectionData (newVal, oldVal) {
      this.generalSkills = this.sectionData.skills.filter(
        s => Value.skill.generalAll().includes(s)).map((item) => {
        return `${Readable.skill.from(item)}${(item === 'injection' && this.sectionData.skillOptions.injection.detail.length > 0) ? (' (' + this.sectionData.skillOptions.injection.detail + ')') : ''}`
      })
      this.othersSkills = this.sectionData.skills.filter(
        s => Value.skill.othersAll().includes(s)).map((item) => {
        return `${Readable.skill.from(item)}${(item === 'injection' && this.sectionData.skillOptions.injection.detail.length > 0) ? (' (' + this.sectionData.skillOptions.injection.detail + ')') : ''}`
      })
    },
  },
  methods: {
    hasChange (data) {
      return this.historiesData && this.historiesData.indexOf(data) > -1
    },
  },
}
</script>
